import script from "./SectionBanners.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionBanners.vue?vue&type=script&setup=true&lang=js"

import "./SectionBanners.vue?vue&type=style&index=0&id=600d6a61&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-600d6a61"]])

export default __exports__